import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    minWidth: theme.spacing(18),
    maxWidth: theme.spacing(18),
    background: theme.palette.custom.background.area,
    zIndex: 2,

    '& .schedule-column-hours-content': {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      overflow: 'hidden',
      borderRight: `solid 1px ${theme.palette.divider}`,
    },
  },
}));

export default styles;
